import { FC, useState } from 'react'
import { Icon } from '@iconify/react'
import { Button, Input } from '@pepper/ui'

import s from './CustomRange.module.css'

type Props = {
  onSubmit: (to: number | null, from: number | null) => void
}

export const CustomRange: FC<Props> = ({ onSubmit }) => {
  const [from, setFrom] = useState<number>()
  const [to, setTo] = useState<number>()
  const [errorMessage, setErrorMessage] = useState('')

  const handleSubmit = () => {
    setTo(undefined)
    setFrom(undefined)
    onSubmit(to ?? 0, from ?? 0)
  }

  const handleChange = ({
    greaterValue,
    lesserValue,
  }: {
    greaterValue?: number
    lesserValue?: number
  }) => {
    if (greaterValue === undefined || lesserValue === undefined) {
      setErrorMessage('')
    } else if (
      !(Number.isInteger(lesserValue) && Number.isInteger(greaterValue)) ||
      lesserValue < 0 ||
      greaterValue <= 0
    ) {
      setErrorMessage('Please enter a whole number')
    } else if (lesserValue >= 0 && greaterValue > 0) {
      if (greaterValue < lesserValue) {
        setErrorMessage('Max value should be greater than Min value')
      } else {
        setErrorMessage('')
      }
    }

    Number.isNaN(greaterValue) ? setTo(undefined) : setTo(greaterValue)
    Number.isNaN(lesserValue) ? setFrom(undefined) : setFrom(lesserValue)
  }

  return (
    <div className={s.customRange}>
      Custom range
      <div className={s.inputWrapper}>
        <Input
          placeholder="From"
          className={s.rangeInput}
          onChange={e => {
            handleChange({
              greaterValue: to,
              lesserValue: e.target.value ? Number(e.target.value) : undefined,
            })
          }}
          error={errorMessage.length > 0}
          value={from}
        />
        <Input
          placeholder="To"
          className={s.rangeInput}
          onChange={e =>
            handleChange({
              greaterValue: e.target.value ? Number(e.target.value) : undefined,
              lesserValue: from,
            })
          }
          error={errorMessage.length > 0}
          value={to}
        />
      </div>
      {errorMessage && (
        <div className={s.error}>
          <Icon icon="ant-design:close-circle-filled" className={s.errorIcon} />
          {errorMessage}
        </div>
      )}
      <Button
        type="primary"
        onClick={() => handleSubmit()}
        size="large"
        disabled={
          errorMessage.length > 0 || from === undefined || to === undefined
        }
      >
        Select
      </Button>
    </div>
  )
}
